import { createApp } from 'vue';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Bugsnag from '@bugsnag/js';
import config from '@/helpers/config';
import store from '@/store'
import router from '@/router';
import App from '@/App.vue';
Bugsnag.start({
  apiKey: config.api.key.bugsnag,
  plugins: [new BugsnagPluginVue()],
  // Never let the session token (Bearer / WS subprotocol) or a connect_string
  // (carries sv_password) reach Bugsnag via metadata or captured request data.
  redactedKeys: [/authorization/i, /sec-websocket-protocol/i, /connect_string/i, /connectString/i, /userToken/i, /access_token/i],
  onError: (event) => {
    try {
      if (event.request && event.request.headers) {
        delete event.request.headers.Authorization;
        delete event.request.headers.authorization;
      }
      // Drop any breadcrumb whose name/metadata carries a WS bearer subprotocol or a
      // connect-string-shaped secret ("connect <ip>; password <pw>").
      const leaky = (s) => typeof s === 'string' && (/bearer\./i.test(s) || /connect\s+\S+;\s*password/i.test(s));
      if (Array.isArray(event.breadcrumbs)) {
        event.breadcrumbs = event.breadcrumbs.filter((b) => !leaky(b.name + ' ' + JSON.stringify(b.metaData || {})));
      }
    } catch (e) {
      // never let scrubbing throw and lose the report
    }
    return true;
  },
});
const bugsnagVue = Bugsnag.getPlugin('vue');
createApp(App).use(store).use(router).use(bugsnagVue).mount('#cslobby');